var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 新東陽 註銷會員 ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("新東陽 註銷會員")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "會員編號"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "placeholder": "請輸入會員編號"
    },
    model: {
      value: _vm.customer_no,
      callback: function callback($$v) {
        _vm.customer_no = $$v;
      },
      expression: "customer_no"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "info",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v(" 註銷 ")])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.customer_no.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)], 1), _c('editor', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "width": "100%",
      "height": "300px",
      "lang": "json",
      "theme": "chrome",
      "disabled": 1
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.result,
      callback: function callback($$v) {
        _vm.result = $$v;
      },
      expression: "result"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }